'use client';

import { MenuItem } from '@mui/material';

import { styled } from '../../styles';
import { Typography } from '../Typography';

import { MenuItemProps } from './types';

export const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<MenuItemProps>(({ theme, isSelected }) => ({
  padding: theme.spacing(2),
  alignItems: 'center',
  color: isSelected ? theme.palette.stateActive : theme.palette.text2,
  '&:hover': {
    background: theme.palette.surface4,
  },
}));

export const MenuItemMediumTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  gap: theme.spacing(2),
  color: 'inherit',
}));

export const MenuItemSmallTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  gap: theme.spacing(1),
  color: 'inherit',
}));
